import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { RecentActivityTitle } from "../../../../Constants/Constants";
import { H6, LI, P, UL } from "../../../../AbstractElements";
import { RecentActivityData } from "../../../../Data/General/Dashboard/Default";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import { Link } from "react-router-dom";

const RecentActivity = () => {
  return (
    <Col xxl="3" xl="4" sm="6" className="box-col-4">
      <Card>
        <DashboardCommonHeader title={RecentActivityTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="latest-activity">
          <UL className="simple-list">
            {RecentActivityData.map((item, index) => (
              <LI className="d-flex align-items-center" key={index}>
                <div className={`flex-shrink-0 bg-light-${item.color}`}>
                  <SvgIcon className={`stroke-icon stroke-${item.color}`} iconId={item.icon} />
                </div>
                <div className="flex-grow-1">
                  <Link to={`${process.env.PUBLIC_URL}/applications/task`}>
                    <H6>{item.title}</H6>
                  </Link>
                  <P>{item.text}</P>
                </div>
                <span>{item.time}</span>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentActivity;
